<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="/enterprise/#/list?field=%E4%BA%A7%E4%B8%9A%E6%95%B0%E5%AD%97%E5%8C%96&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>合作伙伴</span>
      </div>
      <div class="hzhb">
        <el-link>
          <img src="/Public/home/images/b2b/wkjt.jpg" />
          <img src="/Public/home/images/b2b/wssx.jpg" />
          <img src="/Public/home/images/b2b/rb.jpg" />
          <img src="/Public/home/images/b2b/syb.jpg?v=1.0" />
          <img src="/Public/home/images/b2b/zfw.jpg?v=1.0" />
          <img src="/Public/home/images/b2b/wl.jpg" />
          <img src="/Public/home/images/b2b/glgw.jpg" />
          <img
            style="width: 278px; height: 48px"
            src="/Public/home/images/b2b/glgf.png"
          />
        </el-link>
      </div>
    </div> -->

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
    <div style="width: 365px">
        <img style="width: 100%" src="/Public/tuku/69782c8037347.jpg" />
        
    </div>
    <!-- <div style="width: 365px; margin-top: 20px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/cydst.jpg?v=1.0"
        />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "产业数字化",
        tabs: [
          "综合B2B",
          "钢铁电商",
          "工业品电商",
          "塑化电商",
          "农业B2B",
          "纺服B2B",
          "汽车B2B",
          "快消品B2B",
          "餐饮B2B",
          "B2B服务商",
          "其他B2B",
        ],
      },
      year: "",
      time: "",
      platform: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=" +
          this.$store.state.type +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list.slice(0, 10)) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style scoped>
.hzhb img {
  border: 1px double;
  margin: 4px 0;
}
</style>